import { useQuery } from '@apollo/client';
import { gql } from '@apollo/client/core';

const GET_SELLER_SERVICES = gql`
  query SellerServices {
    sellerServices {
      nodes {
        name
      }
    }
  }
`;

export const useGetStarredSellerServices = () => {
  const { loading, error, data, refetch } = useQuery(GET_SELLER_SERVICES, {});

  // Normalize paginated response to flat array for template compatibility
  const services = data?.sellerServices?.nodes || [];

  return { loading, error, data: { starredSellerServices: services }, refetch };
};
